<template>
    <div>
        <transition-group name="list" tag="div">
            <div v-for="(result, index) in results" :key="result.id">
                <slot name="list" :index="index" :result="result" :customProperties="customProperties"></slot>
            </div>
        </transition-group>
        <div v-if="showButton" class="text-center mt-5 mb-5">
            <button @click="loadMore"
                    :disabled="loading"
                    type="button"
                    class="btn btn-primary load-more">
                <div v-if="loading" class="spinner"></div>
                <div :style="{visibility: loading ? 'hidden' : 'visible'}">{{ transLoadMore }}</div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'load-more',
    props: {
        data: {
            type: String,
            required: false
        },
        startFromIndex: {
            type: Number,
            default: 0
        },
        limit: {
            type: Number,
            default: 10
        },
        customProperties: {
            type: Object,
            default: () => ({})
        },
        transLoadMore: {
            type: String,
            default: 'Load more'
        },
        route: {
            type: String,
            required: false
        },
        loadAll: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            results: [],
            fetchedData: [],
            offset: 0,
            totalResults: 0,
            showButton: true,
            loading: false,
            reviewType: null,
            allAreLoaded: false,
        }
    },
    methods: {
        loadMore() {
            this.loading = true;

            if (this.allAreLoaded) {
                this.showMore(); // all are already loaded so show more
                return;
            }

            if (this.route) { // get data from api
                this.getResults();
                return;
            }

            this.results.push(...this.fetchedData.slice(this.offset, this.offset + this.limit));

            this.offset += this.limit;

            this.loading = false;

            if (this.offset >= this.totalResults) {
                this.showButton = false;
            }
        },
        showMore() {
            let newlyDisplayed = 0;
            let initialOffset = this.offset;

            this.results = this.results.map((item, index) => {
                if (newlyDisplayed < this.limit) {
                    let initialDisplay = item.shouldDisplay;

                    if (this.reviewType === '1') {
                        item.shouldDisplay = item.rating > 3;
                    } else if (this.reviewType === '0') {
                        item.shouldDisplay = item.rating <= 3;
                    } else {
                        item.shouldDisplay = true;
                    }

                    if (index >= initialOffset - this.limit) {
                        this.offset++;
                    }

                    if (item.shouldDisplay && !initialDisplay) {
                        newlyDisplayed++;
                    }
                }

                return item;
            });

            this.loading = false;

            if (this.offset - this.limit >= this.results.length) {
                this.showButton = false;
            }
        },
        getResults() {
            const url = new URL(this.route);

            url.searchParams.set('limit', this.limit.toString());
            url.searchParams.set('offset', this.offset.toString());
            url.searchParams.set('load_all', this.loadAll.toString());

            let self = this;

            axios.get(url)
                .then(function (response) {

                    if (response.data.length === 0) {
                        self.loading = false;
                        self.showButton = false;
                        return;
                    }

                    if (self.loadAll) {
                        self.allAreLoaded = true;
                    }

                    let mappedResponse = self.mapResponse(response.data);

                    self.results.push(...mappedResponse);

                    self.offset += self.limit;

                    self.loading = false;

                    if (response.data.length < self.limit) {
                        self.showButton = false;
                    }
                })
                .catch(function (error) {
                    self.loading = false;
                });
        },
        handleFeedbackFilter(event) {
            this.reviewType = event.detail;

            if (this.loadAll) {
                if (!this.allAreLoaded) {
                    this.loadMore();
                }

                if (this.allAreLoaded) {
                    this.showMore();
                    this.showButton = false;
                }
            }
        },
        mapResponse(data) {
            let newlyDisplayed = 0;

            return data.map((item) => {
                if (this.allAreLoaded) {
                    if (newlyDisplayed < this.limit) {
                        let initialDisplay = item.shouldDisplay;

                        if (this.reviewType === '1') {
                            item.shouldDisplay = item.rating > 3;
                        } else if (this.reviewType === '0') {
                            item.shouldDisplay = item.rating <= 3;
                        } else {
                            item.shouldDisplay = true;
                        }

                        if (item.shouldDisplay && !initialDisplay) {
                            newlyDisplayed++;
                        }
                    }

                    return item;
                }

                if (this.reviewType === null) {
                    item.shouldDisplay = true;
                    return item;
                }

                if (this.reviewType === '1') {
                    item.shouldDisplay = item.rating > 3;
                    return item;
                }

                if (this.reviewType === '0') {
                    item.shouldDisplay = item.rating <= 3;
                    return item;
                }
            });
        },
    },
    created() {
        window.addEventListener('feedback-filter', this.handleFeedbackFilter);
    },
    mounted() {
        if (! this.route && ! this.data) {
            this.showButton = false;
            return;
        }

        this.offset = this.startFromIndex;

        if (this.data) { // set existing fetched data
            this.fetchedData = JSON.parse(this.data);

            this.totalResults = this.fetchedData.length;

            if (this.offset >= this.totalResults) {
                this.showButton = false;
            }

            return;
        }

        if (this.offset < this.limit) {
            this.showButton = false;
        }
    },
    beforeDestroy() {
        window.removeEventListener('feedback-filter', this.handleFeedbackFilter);
    }
}
</script>

<style scoped>
.list-enter-active, .list-leave-active {
    transition: all 0.4s;
}

.list-enter, .list-leave-to {
    opacity: 0;
    transform: translateY(30px);
}

.load-more {
    width: auto;
    height: 32px;
    padding: 5px 15px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/LoadMore.vue